import { ButtonPrimaryV2, Modal, colors, colors2, getBreakPoint, icons, SANS_2, transition, UI_BODY_SEMIBOLD_SM_DF } from "oolib";
import React, {Fragment, useState} from "react";
import styled, { css } from "styled-components";
import { trackEventGA } from "../../../../../../../trackers/GA/trackEventGA";
import { __CheckAccessToPublishCTA } from "../../../../../../../utils/accessControl";
import { useGetQueryData } from "../../../../../../../utils/react-query-hooks/general";
import { _Locale } from "../../../../../../locale/Locale";
import { usePlatformBuilderContext } from "../../../../../../../contexts/platformBuilderContext";
import ChooseContentTypeBody from "../../../../../../organisms/ChooseContentTypeBody";
const { PencilLine, PaperPlaneTilt } = icons
const { white, greyColor100} = colors

const { black, primaryContainer, onPrimary } = colors2

const StyledButton = styled(ButtonPrimaryV2)`
  border-radius: 2.7rem;

  ${({ isSmallScreen }) => isSmallScreen ? css`
      padding: 1.2rem;
  ` : css`
      padding: 0.9rem 1.4rem;
      padding-left: 1.2rem;
  `}

`;

export const HeaderPublishButton = ({ config, isSmallScreen }) => {
  const {inGlobalNavBuilder} = usePlatformBuilderContext()
  const [showModal, setShowModal] = useState(false);

  const {
    deployment: { _ContributeCTAText },
  } = config;

  const {user} = useGetQueryData('userData') || {}

  // if no text then don't show the button
  if(!_ContributeCTAText) return null

  if(!__CheckAccessToPublishCTA(user)) return null;

  return (
    <Fragment>
      <div onClick={() => {
        if (inGlobalNavBuilder) return;
        trackEventGA("Publishing Flow","Clicked Publish CTA Button On Header");
        setShowModal(true);
      }}>
        <StyledButton
          id="okf_publish_cta"
          typo="UI_BODY_SEMIBOLD_SM_DF"
          responsive
          iconSize={!isSmallScreen ? "S" : "M"}
          icon={"PencilSimple"}
          children={!isSmallScreen && _ContributeCTAText}
          isSmallScreen={isSmallScreen}/> {/** Id is v. important for coachmark to work */}
      </div>
      {showModal && (
        <Modal
          title="Choose Template"
          onClose={() => setShowModal(false)}
          desktopWidth="60%"
          fitToContentHeight
        >
          <ChooseContentTypeBody />
        </Modal>
      )}
    </Fragment>
  );
};
